module.exports = __webpack_public_path__ + "img/icon-graduate-hat.e7d4dc1f.svg";